export default function PageHeader({ eyebrow, title, actions, description }) {
  return (
    <header className="border-b border-zinc-200 bg-white">
      <div className="px-8 py-8">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="min-w-0">
            {eyebrow && (
              <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#0044FF] mb-2">
                {eyebrow}
              </div>
            )}
            <h1 className="font-display text-3xl md:text-4xl tracking-tight text-zinc-950">
              {title}
            </h1>
            {description && (
              <p className="mt-2 text-sm text-zinc-600 max-w-2xl">{description}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
        </div>
      </div>
    </header>
  );
}

export function Stat({ label, value, hint, testId }) {
  return (
    <div className="bg-white border border-zinc-200 p-6" data-testid={testId}>
      <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">{label}</div>
      <div className="font-display text-4xl text-zinc-950 mt-2 tracking-tight">{value}</div>
      {hint && <div className="text-xs text-zinc-500 mt-2">{hint}</div>}
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const styles = {
    primary: "bg-[#0044FF] hover:bg-[#0033CC] text-white",
    ghost: "border border-zinc-900 text-zinc-950 hover:bg-zinc-900 hover:text-white",
    danger: "border border-red-600 text-red-700 hover:bg-red-600 hover:text-white",
    dark: "bg-zinc-950 text-white hover:bg-zinc-800",
  };
  return (
    <button
      className={`px-4 py-2.5 text-sm font-medium inline-flex items-center gap-2 transition-colors disabled:opacity-60 ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
